import OrderSelectSites from 'components/order/orderSelectSites/OrderSelectSites'
import { GetStaticProps } from 'next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  return <OrderSelectSites continueHref={`/store/checkout`} siteHref={`/store/site/`} />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, ['device', 'pricing_plan'], true)) } }
}
